export default __webpack_public_path__ + "static/media/nick_carr.8816a1c0.jpg";